import { EventoFeriaEscolarComponent } from './../evento-feria-escolar/evento-feria-escolar.component';
import { EventoConferenciaComponent } from './../evento-conferencia/evento-conferencia.component';
import { MarketplaceService } from './../../../core/services/marketplace.service';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SubdominiosService } from 'src/app/core/services/dominios.service';
import { EventosService } from 'src/app/core/services/eventos.service';
import { UsuarioService } from 'src/app/core/services/usuario.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import Swal from 'sweetalert2';
import { EventoComponent } from '../evento/evento.component';
import { EventoFeriaComponent } from '../evento-feria/evento-feria.component';
import { FeriaService } from 'src/app/core/services/feria.service';

@Component({
  selector: 'app-lista-eventos',
  templateUrl: './lista-eventos.component.html',
  styleUrls: ['./lista-eventos.component.scss'],
})
export class ListaEventosComponent implements OnInit {
  activeOption = 'propios';
  public usuario = null;
  public empresa = null;
  public marketplaces = null;
  public ferias = null;
  public fecha_de_pago_subdominio = null;
  public data_for_url = {};

  constructor(
    private svUtils: UtilsService,
    private svUsuario: UsuarioService,
    private dialog: MatDialog,
    private svDomain: SubdominiosService,
    private svMarketplaces: MarketplaceService,
    private svFerias: FeriaService,
    private svEventos: EventosService
  ) {}

  ngOnInit(): void {
    this.getLoggedUser();
  }

  desableEvents() {
    this.svEventos.disableEvents().subscribe((resp) => {
      console.log(resp);
    });
  }

  getOptionSeleted(option) {
    this.activeOption = option;
  }

  getLoggedUser() {
    this.usuario = this.svUtils.getLoggedUser();
    this.desableEvents();

    if (this.usuario.id_empresa_perteneciente) {
      this.getCompany(this.usuario.id_empresa_perteneciente);
      this.getMarketplaces(this.usuario.id_usuario);
      this.getFerias(this.usuario.id_usuario);
    }
  }
  getCompany(id_empresa_usuario) {
    this.svUsuario.getCompany(id_empresa_usuario).subscribe((resp) => {
      if (resp['status'] === 'success') {
        resp = resp['body']['data'][0];
        this.empresa = resp;
        this.fecha_de_pago_subdominio = this.empresa['fecha_pago_subdominio'];
        let fecha_convertida = new Date(this.fecha_de_pago_subdominio);
        let final_fecha_pago = null;
        let fecha_actual = Date.now();

        if (this.empresa['es_demo'] == 'demo_default') {
        } else {
          if (this.empresa['es_demo'] == 'No') {
            final_fecha_pago = fecha_convertida.setDate(
              fecha_convertida.getDate() + 30
            );
          } else {
            final_fecha_pago = fecha_convertida.setDate(
              fecha_convertida.getDate() + 1
            );
          }
        }

        if (fecha_actual > final_fecha_pago) {
          let subd = {
            id_subdominio: this.empresa['id_subdominio'],
            id_usuario_subdominio: this.empresa['id_usuario'],
            cuenta_activa_subdominio: 'No',
          };

          this.svDomain.updateDomain(subd).subscribe((resp_subd) => {
            if (resp_subd['result']['data'][0]) {
              resp['cuenta_activa_subdominio'] =
                resp_subd['result']['data'][0]['cuenta_activa_subdominio'];
            }
          });
        }

        localStorage.setItem('empresa', JSON.stringify(resp));
      }
    });
  }

  openMarketplaceEventModal() {
    if (this.empresa['cuenta_activa_subdominio'] == 'No') {
      Swal.fire(
        'Cuenta inactiva',
        'Debes comprar un plan comercial para crear eventos',
        'warning'
      );
      return;
    }
    const dialogRef = this.dialog.open(EventoComponent, {
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
  }

  openFeriaEventModal() {
    if (this.empresa['cuenta_activa_subdominio'] == 'No') {
      Swal.fire(
        'Cuenta inactiva',
        'Debes comprar un plan comercial para crear eventos',
        'warning'
      );
      return;
    }
    const dialogRef = this.dialog.open(EventoFeriaComponent, {
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
  }
  openConferenciaEventModal() {
    if (this.empresa['cuenta_activa_subdominio'] == 'No') {
      Swal.fire(
        'Cuenta inactiva',
        'Debes comprar un plan comercial para crear eventos',
        'warning'
      );
      return;
    }
    const dialogRef = this.dialog.open(EventoConferenciaComponent, {
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
  }
  openFeriaEscolarEventModal() {
    if (this.empresa['cuenta_activa_subdominio'] == 'No') {
      Swal.fire(
        'Cuenta inactiva',
        'Debes comprar un plan comercial para crear eventos',
        'warning'
      );
      return;
    }
    const dialogRef = this.dialog.open(EventoFeriaEscolarComponent, {
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: {},
    });
  }
  verifyEvent(id_evento) {
    this.svEventos.verifyEvent(id_evento).subscribe((resp) => {});
  }
  getMarketplaces(id_usuario) {
    this.svMarketplaces.getMarketplaces(id_usuario).subscribe((_market) => {
      if (_market) {
        if (_market['body']) {
          if (_market['body']['status'] == 'success') {
            this.marketplaces = _market['body']['data'];
          }
        }
      }
    });
  }
  getFerias(id_usuario) {
    this.svFerias.getFerias(id_usuario).subscribe((_feria) => {
      if (_feria) {
        if (_feria['body']) {
          if (_feria['body']['status'] == 'success') {
            this.ferias = _feria['body']['data'];
          }
        }
      }
    });
  }
  truncateText(texto) {
    return texto.substr(0, 30) + '...';
  }
  editEvent(id_evento, tipo_evento) {
    let id_tipo_evento = id_evento;
    let nombre_id_tipo = 'id_marketplace';

    if (tipo_evento == 'feria') {
      nombre_id_tipo = 'id_feria';
    }

    let empresa = JSON.parse(localStorage.getItem('empresa'));

    this.data_for_url = {
      id_empresa_usuario: empresa.id_empresa_usuario,
      token: this.svUtils.getAt(),
    };
    this.data_for_url[nombre_id_tipo] = id_tipo_evento;
    this.data_for_url = btoa(JSON.stringify(this.data_for_url));

    if (tipo_evento == 'feria') {
      window.open(
        `${empresa.subdominio_empresa_usuario}/admin-feria/?ed=${this.data_for_url}`,
        '_blank'
      );
    } else {
      window.open(
        `${empresa.subdominio_empresa_usuario}/admin/?ed=${this.data_for_url}`,
        '_blank'
      );
    }
  }

  visitEvent(id_evento, tipo_evento, tipo_feria?) {
    let nombre_id_tipo = 'id_marketplace';
    if (tipo_evento == 'feria') {
      nombre_id_tipo = 'id_feria';
    }

    let empresa = JSON.parse(localStorage.getItem('empresa'));
    this.data_for_url = {
      id_empresa_usuario: empresa.id_empresa_usuario,
      token: this.svUtils.getAt(),
    };
    this.data_for_url[nombre_id_tipo] = id_evento;
    this.data_for_url = btoa(JSON.stringify(this.data_for_url));
    if (tipo_evento == 'feria') {
      this.data_for_url['tipo_feria'] = tipo_feria;
    }
    let url = `${empresa.subdominio_empresa_usuario}/admin/?`;

    if (tipo_evento == 'feria') {
      url = `https://expoeventvr.infoverses.com/feria/personalizacion/?`;
    } else {
      url = `https://eventvr.infoverses.com/marketplace/personalizacion/?`;
    }

    window.open(`${url}ed=${this.data_for_url}`, '_blank');
  }
}
